import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import styles from './Process.module.css';
import cowimg from "../../assets/gir.jpg"
import processVideo from "../../assets/wp-images/vid1.mp4"

const Process = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const steps = [
    {
      number: 1,
      title: 'Gir Cows Grazing Naturally',
      gujarati: 'ગીર ગાયો કુદરતી રીતે ચરે છે',
      description: 'Our Gir cows graze freely on organic grass and herbs in open pastures, ensuring they are healthy and stress-free.',
      icon: cowimg,
    },
    {
      number: 2,
      title: 'Fresh Milking Tradition',
      gujarati: 'તાજા દૂધનું પરંપરાગત દોહન',
      description: 'Cows are milked traditionally by hand with love and care, maintaining the purity and natural properties of milk.',
      icon: '🥛',
    },
    {
      number: 3,
      title: 'Curd Preparation',
      gujarati: 'દહીંની તૈયારી',
      description: 'Fresh milk is boiled and cooled to the right temperature, then cultured naturally to make thick, creamy curd.',
      icon: '🥣',
    },
    {
      number: 4,
      title: 'Wooden Bilona Churning',
      gujarati: 'લાકડાના બિલોણાથી મથવું',
      description: 'The curd is hand-churned using traditional wooden bilona (churner) in a rhythmic motion to extract pure butter.',
      icon: '🥄',
    },
    {
      number: 5,
      title: 'Heating on Low Flame',
      gujarati: 'ધીમા તાપે ગરમ કરવું',
      description: 'The butter is slowly heated on a low flame until it transforms into golden, aromatic ghee with all nutrients intact.',
      icon: '🔥',
    },
    {
      number: 6,
      title: 'Packing with Purity',
      gujarati: 'શુદ્ધતા સાથે પેકિંગ',
      description: 'The pure ghee is carefully filtered and packed in food-grade glass jars, preserving its freshness and quality.',
      icon: '🏺',
    },
  ];

  return (
    <div className={styles.process}>
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <h1>From Gir Cow to Ghee</h1>
          <p className="gujarati-text">ગીર ગાયથી ઘી સુધી</p>
          <p className={styles.subtitle}>A Pure Journey of Tradition</p>
        </div>
      </section>

      <section className={`${styles.processSection} texture-bg`}>
        <div className="container">
          <div className={styles.intro}>
            <h2>Our Traditional Bilona Method</h2>
            <p className="gujarati-text">અમારી પરંપરાગત બિલોણા પદ્ધતિ</p>
            <p className={styles.introText}>
              We follow the ancient Vedic method passed down through generations.
              Every step is done with care, patience, and respect for tradition,
              ensuring you get the purest and most nutritious ghee.
            </p>
          </div>

          <div className={styles.timeline}>
            {steps.map((step, index) => (
              <motion.div
                key={step.number}
                className={styles.timelineItem}
                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <div className={styles.stepNumber}>{step.number}</div>

                <div className={styles.stepContent}>
                  <div className={styles.stepIcon}>
                    {typeof step.icon === 'string' && step.icon.length < 10 ? (
                      step.icon
                    ) : (
                      <img src={step.icon} alt={step.title} className={styles.iconImage} />
                    )}
                  </div>
                  <h3>{step.title}</h3>
                  <p className={`${styles.stepGujarati} gujarati-text`}>{step.gujarati}</p>
                  <p className={styles.stepDescription}>{step.description}</p>
                </div>

                <div className={styles.connector}></div>
              </motion.div>
            ))}
          </div>

          <div className={styles.videoSection}>
            <h2>Our Happy Cows</h2>
            <p className="gujarati-text">અમારી ગૌશાળા</p>
            <div className={styles.videoContainer}>
              <video
                className={styles.videoElement}
                controls
                autoPlay
                muted
                loop
                playsInline
              >
                <source src={processVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>

          <div className={styles.qualitySection}>
            <h2>Our Quality Promise</h2>
            <p className="gujarati-text">અમારું ગુણવત્તાનું વચન</p>

            <div className={styles.qualityGrid}>
              <div className={styles.qualityCard}>
                <span className={styles.qualityIcon}>✓</span>
                <h4>No Chemicals</h4>
                <p>100% natural, no preservatives or additives</p>
              </div>
              {/* <div className={styles.qualityCard}>
                <span className={styles.qualityIcon}>✓</span>
                <h4>AProtein</h4>
                <p>Pure Gir cow milk with A2 beta-casein</p>
              </div> */}
              <div className={styles.qualityCard}>
                <span className={styles.qualityIcon}>✓</span>
                <h4>Hand-Made</h4>
                <p>Traditional hand-churning process</p>
              </div>
              <div className={styles.qualityCard}>
                <span className={styles.qualityIcon}>✓</span>
                <h4>Lab Tested</h4>
                <p>Quality tested for purity and nutrition</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Process;
